import { render } from "./assetNoteModal.vue?vue&type=template&id=2722e94b&scoped=true"
import script from "./assetNoteModal.vue?vue&type=script&lang=js"
export * from "./assetNoteModal.vue?vue&type=script&lang=js"

import "./assetNoteModal.vue?vue&type=style&index=0&id=2722e94b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2722e94b"]])

export default __exports__